<template>
  <div>
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label>Unidade</label>
          <input 
          v-model="contratoSelecionado.unidade.nome"
          class="form-control"
          type="text"
          :disabled="true" 
          >
        </div>

      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>Tipo do Contrato</label>
          <input 
          :value="contratoSelecionado.tipo | tipoContrato"
          class="form-control"
          type="text"
          :disabled="true" 
          >
        </div>

      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>Data Inicial</label>
          <input 
          :value="contratoSelecionado.data_inicial | dataFormatada"
          class="form-control"
          type="text"
          :disabled="true" 
          >
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>Data Final</label>
          <input 
          :value="contratoSelecionado.data_final | dataFormatada"
          class="form-control"
          type="text"
          :disabled="true" 
          >
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>Limite Geral</label>
          <input 
          :value="contratoSelecionado.limite_geral | numberFormat(2,',','.')"
          class="form-control"
          type="text"
          :disabled="true" 
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
 import axios from "axios"; // Cliente para requisição http

 export default {
  props: ['contratoId'],
  filters: {
    
  },
  data: () => ({
    contratoSelecionado: {
      tipo: null,
      data_inicial: null,
      data_final: null,
      limite_geral: null,

      unidade: {
        nome: ''
      }
    },
  }),
  mounted() {
    this.getDataContrato(this.$props.contratoId);
  },
  methods: {
    getDataContrato (contratoId) {
      let config = this.$store.getters.getHeaderAuth;
      axios.get(`${this.$store.state.serverURI}/api/distribuicao/contratos/getById/${contratoId}`, config)
      .then(response => {
        this.contratoSelecionado = response.data;
        this.$store.commit('TOGGLE_LOADING');
      }).catch((error) => { this.$store.commit('throwException', error); });    
    },
  },
  watch: {},
  components: {}
};
</script>

<style scoped>
  * {
    box-sizing: border-box;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
  }

  .modal-container {
    width: 70%;
    margin: 40px auto 0;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #333;
  }

  .modal-body {
    margin: 10px 0;
  }

  .text-right {
    text-align: right;
  }

  .form-label {
    display: block;
    margin-bottom: 1em;
  }

  .form-label > .form-control {
    margin-top: 0.5em;
  }

  .form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
  }

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

 .modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal {
  display: block !important; /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important;
}
.modal-body {
  height: 350px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// cabecarioContrato.vue?2d94f82c